// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(240deg, #038cf4, #79c6e9);
}

.reset-password-box {
  background: #fff;
  padding: 20px 40px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

.reset-password-header {
  text-align: center;
  margin-bottom: 20px;
}

.reset-password-header h2 {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.reset-password-form {
  display: flex;
  flex-direction: column;
}

.reset-password-form .form-group {
  margin-bottom: 15px;
}

.reset-password-form label {
  display: block;
  margin-bottom: 5px;
  color: #555;
}

.reset-password-form input {
  width: 99%;
  /* padding: 10px; */
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
}

.reset-password-header h3 {
  font-size: 2rem;
  margin-bottom: 20px;
  text-align: left;
}

.reset-password-form button {
  /* padding: 10px 15px; */
  background-color: #07a6ef;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.reset-password-form button:hover {
  background-color: #1976d2;
}

.error-message {
  color: red;
  margin-top: 10px;
  font-size: 14px;
}

.success-message {
  color: green;
  margin-top: 10px;
  font-size: 14px;
}

.resetPasswordInfoMessage {
  margin-left: 0px;
}

.additional-links-forgot-password {
  margin-top: 20px;
  font-weight: 600;
  font-size: 17px;
  text-decoration: none;
  text-align: center;
}

.additional-links-forgot-password a {
  margin-right: 10px;
  color: #333;
  text-decoration: none;
  color: #07a6ef;
}

.otpLoadingBox {
  display: flex;
}

.otp-loading-forgot-password {
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Css/AdminRegister.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".reset-password-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 100vh;\r\n  background: linear-gradient(240deg, #038cf4, #79c6e9);\r\n}\r\n\r\n.reset-password-box {\r\n  background: #fff;\r\n  padding: 20px 40px;\r\n  border-radius: 10px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  max-width: 400px;\r\n  width: 100%;\r\n}\r\n\r\n.reset-password-header {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.reset-password-header h2 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  color: #333;\r\n}\r\n\r\n.reset-password-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.reset-password-form .form-group {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.reset-password-form label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  color: #555;\r\n}\r\n\r\n.reset-password-form input {\r\n  width: 99%;\r\n  /* padding: 10px; */\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  font-size: 14px;\r\n}\r\n\r\n.reset-password-header h3 {\r\n  font-size: 2rem;\r\n  margin-bottom: 20px;\r\n  text-align: left;\r\n}\r\n\r\n.reset-password-form button {\r\n  /* padding: 10px 15px; */\r\n  background-color: #07a6ef;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.reset-password-form button:hover {\r\n  background-color: #1976d2;\r\n}\r\n\r\n.error-message {\r\n  color: red;\r\n  margin-top: 10px;\r\n  font-size: 14px;\r\n}\r\n\r\n.success-message {\r\n  color: green;\r\n  margin-top: 10px;\r\n  font-size: 14px;\r\n}\r\n\r\n.resetPasswordInfoMessage {\r\n  margin-left: 0px;\r\n}\r\n\r\n.additional-links-forgot-password {\r\n  margin-top: 20px;\r\n  font-weight: 600;\r\n  font-size: 17px;\r\n  text-decoration: none;\r\n  text-align: center;\r\n}\r\n\r\n.additional-links-forgot-password a {\r\n  margin-right: 10px;\r\n  color: #333;\r\n  text-decoration: none;\r\n  color: #07a6ef;\r\n}\r\n\r\n.otpLoadingBox {\r\n  display: flex;\r\n}\r\n\r\n.otp-loading-forgot-password {\r\n  margin-left: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
